
import api from "@/api/api";
import type {ZAssignment} from "@schemas/assignment.schemas";
import type {AssignmentStatus} from "@typesDef/assignment.types";

export default {
  // locally we have a proxy from /api to VUE_APP_API_PROXY_TARGET / which is http://localhost:3000
  endpointUrl: "assignments",
  /**
   * Update the status of an application
   * @param assignmentId
   * @param status
   */
  async updateStatus(assignmentId: string, status: AssignmentStatus): Promise<ZAssignment> {
    if (!assignmentId) {
      throw new Error(`assignmentId is required`);
    }
    try {
      const payload = {
        status
      }
      return await api.patchDocument<ZAssignment>(this.endpointUrl + "/" + assignmentId + "/status", payload);
    } catch (error) {
      console.error('Error updateStatus:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  },
}
